import Description from '../../Description';
import Footer from '../../Footer';
import Banner from '../../Banner';
import Grid from '@mui/material/Unstable_Grid2';
import {Box} from '@mui/material';
import {Card, CardContent} from '../../Card';

const SurveyLayout= ({ children }) => {
  return (      
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={2}>
        <Grid xs={12}>
          <Banner />
        </Grid>
        <Grid container spacing={2} xs={12} justifyContent="center">
          <Grid xs={12} md={8}>
            <Card sx={{mt:8}}>
              <CardContent>                      
                <Description />              
                {children}
              </CardContent>
            </Card>        
          </Grid>
        </Grid>
        <Grid xs={12}>              
          <Footer />
        </Grid>
      </Grid>               
    </Box>      
  );  
};

export default SurveyLayout;
